import { useMemo, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface FramerateProfilesListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
    name: string;
}

const defaultFilters: FramerateProfilesListingFilters = {
    sortBy: "updatedDate",
    sortOrder: "desc",
    name: "",
    page: 1,
    pageSize: 50
};

export const useFramerateProfilesListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<FramerateProfilesListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<FramerateProfilesListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [filters]);

    const setSort = (sort: ListTableSort): void => {
        setFilters((prevFilters: FramerateProfilesListingFilters) => ({
            ...prevFilters,
            page: 1,
            pageSize: 50,
            sortBy: sort.by,
            sortOrder: sort.order
        }));
    };
    const setPage = (page: number) => {
        setFilters((prevFilters: FramerateProfilesListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: FramerateProfilesListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    const setName = (name: string): void => {
        setFilters((prevFilters: FramerateProfilesListingFilters) => ({ ...prevFilters, name, page: 1 }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setName,
        setSort,
        setPage,
        setPageSize,
        clearFilters
    };
};
